/**
 * Magic-link landing page. Exchanges the token for a session cookie, then redirects.
 */

import { useEffect, useState, type ReactNode } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api.js';

export function AuthCallbackPage({ onSignedIn }: { onSignedIn: () => void }): ReactNode {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('That link is missing its token.');
      return;
    }
    api
      .post('/api/auth/callback', { token })
      .then(() => {
        onSignedIn();
        navigate('/properties', { replace: true });
      })
      .catch((err: unknown) =>
        setError(err instanceof Error ? err.message : 'That sign-in link did not work.'),
      );
  }, [params, navigate, onSignedIn]);

  return (
    <div className="signin">
      <div className="card signin-card">
        {error ? (
          <>
            <h1>Sign-in failed</h1>
            <div className="alert">{error}</div>
            <a href="/">Try again</a>
          </>
        ) : (
          <h1>Signing you in…</h1>
        )}
      </div>
    </div>
  );
}
